import { __awaiter, __generator } from "tslib";
import { logError, logPerformance } from '@office-start/telemetry-service';
import { updateUserSetting } from './operations/patchUserSetting';
export function applyUserSettingChange(_a) {
    var userPinningStatus = _a.userPinningStatus, userStorageOptions = _a.userStorageOptions;
    return __awaiter(this, void 0, void 0, function () {
        var startTime, response, error_1, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    startTime = Date.now();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateUserSetting({
                            userPinningStatus: userPinningStatus,
                            userStorageOptions: userStorageOptions,
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _b.sent();
                    errorMessage = 'Unable to apply user setting change';
                    logError({
                        eventName: "CopiltotFre" /* KnownFeatureNames.CopilotFre */,
                        errorType: 'Patch_User_Setting_Error',
                        message: errorMessage,
                        debugInfo: "Details: ".concat(error_1 instanceof Error ? error_1.message : error_1),
                    });
                    throw new Error("".concat(errorMessage, ": ").concat(error_1 instanceof Error ? error_1.message : error_1));
                case 4:
                    logPerformance({
                        eventName: 'CopilotFre_PatchUserPinSetting',
                        latency: Date.now() - startTime,
                    });
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=userSettingContext.js.map